import { render, staticRenderFns } from "./cell-group.vue?vue&type=template&id=2f49f362&"
import script from "./cell-group.vue?vue&type=script&lang=js&"
export * from "./cell-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports